import React from 'react';
import { Spin } from 'antd';

export enum IndicatorSize {
	small = 'small',
	default = 'default',
	large = 'large'
}

interface IProps {
	/** Classname for the outer container */
	outContainerClassName?: string | undefined;
	/** Classname for the inner container */
	innerContainerClassName?: string | undefined,
	indicatorSize?: IndicatorSize | IndicatorSize.default,
	indicatorShowDelay?: number
}

export function LoadingIndicator(props: IProps) {
	const spinElement = props.indicatorShowDelay ?
		<Spin size={props.indicatorSize} delay={props.indicatorShowDelay} /> :
		<Spin size={props.indicatorSize} />;

	return (
		<div className={props.outContainerClassName}>
			<div className={props.innerContainerClassName}>
				{spinElement}
			</div>
		</div>
	);
};

export function LargeLoadingIndicator(props: IProps) {
	return (
		<LoadingIndicator
			outContainerClassName="pos-rel h-vh-90"
			innerContainerClassName="pos-abs-center"
			indicatorSize={IndicatorSize.large}
		/>
	);
}